import { FieldType, PubOtherField } from '../../../components/GenericSection/constants';
/** field list for Miscellaneous form publication info section */
export var MISCELLANEOUS_FORM_PUB_INFO_SECTION_FIELD_LIST = [{
  type: FieldType.TEXT,
  labelText: 'Location',
  recommended: true,
  field: PubOtherField.LOCATION
}, {
  type: FieldType.TEXT,
  labelText: 'City',
  recommended: true,
  field: PubOtherField.CITY
}];